import { useLingui } from "@lingui/react";
import FieldValuePair from "../FieldValuePair.tsx";
import type { SpecProps } from "./types.ts";

export const VehicleGroup = ({ segment }: SpecProps<"segment">) => {
  const { i18n } = useLingui();

  if (!segment) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.common.vehicleGroup",
    message: "Vehicle group",
    comment: "Field for 'Vehicle group' in ad specification",
  });

  return <FieldValuePair field={field} value={segment} />;
};
